module.exports = "<div class=\"dui-def\">\n  <div class=\"dui-def-term\">{{ t('vlanDetails.vlanId')|e }}</div>\n  <div data-tag=\"deets-vlan-name\" class=\"dui-def-value\">{{ tagId|e }}</div>\n  <hr>\n</div>\n\n";
